export const qualityChecks = (state = [], action) => {
  if (action.type === 'FETCH_QUALITY_CHECKS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_QUALITY_CHECKS') {
    return [];
  }
  return state;
};

export const qualityCheck = (state = {}, action) => {
  if (action.type === 'FETCH_QUALITY_CHECK') {
    return action.payload;
  }
  if (action.type === 'CLEAR_QUALITY_CHECK') {
    return {};
  }
  return state;
};

export const debitNotes = (state = [], action) => {
  if (action.type === 'FETCH_DEBIT_NOTES') {
    return action.payload;
  }
  if (action.type === 'CLEAR_DEBIT_NOTES') {
    return [];
  }
  return state;
};

export const qualityCheckView = (state = {}, action) => {
  if (action.type === 'FETCH_QUALITY_CHECK_VIEW') {
    return action.payload;
  }
  if (action.type === 'CLEAR_QUALITY_CHECK_VIEW') {
    return {};
  }
  return state;
};

export const qualityCheckFiles = (
  state = {
    fabrics: [{ files: [] }],
    fabricsFileArray: { 0: [] },
    fabricsIndexes: {},
    items: [{ files: [] }],
    itemsFileArray: { 0: [] },
    itemsIndexes: {},
    accessories: [{ files: [] }],
    accessoriesFileArray: { 0: [] },
    accessoriesIndexes: {},
    styles: [{ files: [] }],
    stylesFileArray: { 0: [] },
    stylesIndexes: {},
  },
  action
) => {
  if (action.type === 'SET_QUALITY_CHECK_FILES') {
    const { itemIndex, file, isRemove = false, itemType } = action.payload;

    if (!isRemove) {
      if (!state[itemType][itemIndex]) {
        state[itemType][itemIndex] = { files: [file] };
        state[`${itemType}FileArray`][itemIndex] = [file.name];
      } else {
        state[itemType][itemIndex].files.push(file);
        state[`${itemType}FileArray`][itemIndex].push(file.name);
      }
      state[`${itemType}Indexes`][file.name] = itemIndex;
    } else if (state[itemType][itemIndex]) {
      const index = state[itemType][itemIndex].files.indexOf(file);

      if (index > -1) {
        state[itemType][itemIndex].files.splice(index, 1);
        state[`${itemType}FileArray`][itemIndex].splice(index, 1);
      }
      delete state[`${itemType}Indexes`][file.name];
    }

    const newState = { ...state };

    return newState;
  }

  if (action.type === 'DELETE_QUALITY_CHECK_ITEM') {
    const { itemIndex, itemType } = action.payload;

    state[itemType].splice(itemIndex, 1);

    delete state[`${itemType}FileArray`][itemIndex];

    for (const key of Object.keys(state[`${itemType}FileArray`]).sort()) {
      if (key === itemIndex) {
        delete state[`${itemType}FileArray`][key];
      }
      if (key > itemIndex) {
        state[`${itemType}FileArray`][key - 1] =
          state[`${itemType}FileArray`][key];

        delete state[`${itemType}FileArray`][key];
      }
    }

    for (const [key, value] of Object.entries(state[`${itemType}Indexes`])) {
      if (value === itemIndex) {
        delete state[`${itemType}Indexes`][key];
      }
      if (value > itemIndex) {
        state[`${itemType}Indexes`][key] = value - 1;
      }
    }

    const newState = { ...state };

    return newState;
  }

  if (action.type === 'CLEAR_QUALITY_CHECK_FILES') {
    return {
      fabrics: [{ files: [] }],
      fabricsFileArray: { 0: [] },
      fabricsIndexes: {},
      items: [{ files: [] }],
      itemsFileArray: { 0: [] },
      itemsIndexes: {},
      accessories: [{ files: [] }],
      accessoriesFileArray: { 0: [] },
      accessoriesIndexes: {},
      styles: [{ files: [] }],
      stylesFileArray: { 0: [] },
      stylesIndexes: {},
    };
  }

  return state;
};

export const qcReport = (state = { items: [], summary: [] }, action) => {
  if (action.type === 'FETCH_QC_REPORT') {
    return action.payload;
  }

  if (action.type === 'CLEAR_QC_REPORT') {
    return { items: [], summary: [] };
  }

  return state;
};
